import StarIcon from "./icons/StarIcon";

const Rating = (props) => {
  const { value } = props;

  return (
    <div className="flex w-fit items-center gap-1.5">
      <StarIcon color={value >= 1 ? "#163317" : "#FFFCF8"} />
      <StarIcon color={value >= 2 ? "#163317" : "#FFFCF8"} />
      <StarIcon color={value >= 3 ? "#163317" : "#FFFCF8"} />
      <StarIcon color={value >= 4 ? "#163317" : "#FFFCF8"} />
      <StarIcon color={value >= 5 ? "#163317" : "#FFFCF8"} />
    </div>
  )
};

export default Rating;